import React from 'react';

class TextBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value ? this.props.value : '',
    };
    this.handleTextBoxValue = this.handleTextBoxValue.bind(this);
    this.handleSubmitTextBoxValue = this.handleSubmitTextBoxValue.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ value: nextProps.value !== undefined ? nextProps.value : '' });
  }
  handleTextBoxValue(e) {
    if (e.key === 'Enter') {
      this.props.grabTextBoxValue(e.target.value);
    }
    this.setState({ value: e.target.value });
  }
  handleSubmitTextBoxValue() {
    this.props.grabTextBoxValue(this.state.value);
  }
  render() {
    // const value = this.props.value !== undefined ? this.state.value : '';
    return (
      <div className="searchbox-input">
        <input type="text" ref="textInput" placeholder={API.LANG.PLACE_SEARCH} className="reactive-input" value={this.state.value} onChange={this.handleTextBoxValue} onKeyPress = {this.handleTextBoxValue}/>
        <button type="submit" onClick={this.handleSubmitTextBoxValue}><i className="fa fa-search"></i></button>
      </div>
    );
  }
}
TextBox.propTypes = {
  'value': React.PropTypes.string,
  'grabTextBoxValue': React.PropTypes.func,
  'isOpenElement': React.PropTypes.string,
};
export default TextBox;



// WEBPACK FOOTER //
// ./assets/src/frontend/element/textbox.js